module.exports = __webpack_public_path__ + "img/005.11a345d1.jpg";